import { cn } from '@cobliteam/ui/utils';
import type { HTMLAttributeAnchorTarget, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useVisitedPage } from '../hooks';

interface LinkWrapperProps {
  to: string;
  pageId: string;
  children: ReactNode;
  className?: string;
  // Precisa vir no `<a>`: o `<button>` interno do rail não nomeia o link.
  'aria-label'?: string;
  target?: HTMLAttributeAnchorTarget;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: (path: string) => void;
  onPageClick?: (path: string) => void;
}

const LinkWrapper = ({ to, pageId, children, className, target = '_self', onClick, onMouseEnter, onMouseLeave, 'aria-label': ariaLabel, ...props }: LinkWrapperProps) => {
  const { trackPageVisit } = useVisitedPage();

  const handleClick = () => {
    // Track the page visit
    if (pageId) {
      trackPageVisit(pageId);
    }

    // Call the original onClick if provided
    if (onClick) onClick(to);
  };

  const isExternal = to.startsWith('http://') || to.startsWith('https://');

  if (isExternal) {
    return (
      <a
        href={to}
        target='_blank'
        rel='noopener noreferrer'
        aria-label={ariaLabel}
        className={cn('line-clamp-1 flex cursor-pointer flex-row text-ellipsis active:text-current', className)}
        onClick={handleClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      to={to}
      target={target}
      aria-label={ariaLabel}
      className={cn('line-clamp-1 flex cursor-pointer flex-row text-ellipsis active:text-current', className)}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...props}
    >
      {children}
    </Link>
  );
};

export default LinkWrapper;
